// extracted by mini-css-extract-plugin
export default {"titleContainer":"ShippingAddress_titleContainer__3wd+s","fullView":"ShippingAddress_fullView__mIAFN","shimmer":"ShippingAddress_shimmer__uylt3"};